import { LiveQuestRewardSlot, liveQuestProductKey } from './liveQuestRewards';

export type StickerPackMember = {
  productKey: string;
  assetUrl: string;
  mimeType: string;
};

/**
 * One stable pack record groups the individually grantable sticker products and also supplies the
 * cover shown on the Live Quest reward card. Re-saving the same reward updates this record instead
 * of creating another pack.
 */
export const buildLiveQuestStickerPackPayload = (
  reward: LiveQuestRewardSlot,
  members: StickerPackMember[],
  environment: 'dev' | 'prod'
) => {
  if (reward.rewardType !== 'stickerPack') throw new Error('The selected Live Quest reward is not a sticker pack.');
  if (members.length < 5 || members.length > 10) throw new Error('A Live Quest sticker pack must contain 5 to 10 stickers.');

  const cover = members[0];
  return {
    ProductKey: liveQuestProductKey(reward.id),
    Name: `Live Quest ${reward.track === 'basic' ? 'Basic' : 'Plus'} LV ${reward.level}: ${reward.title}`,
    Description: reward.subtitle,
    CategoryKey: 'LIVE_QUEST',
    Type: 'utility',
    AvailabilityType: 'unlimited',
    CurrencyType: 'coin',
    PriceCoins: 0,
    PriceTokens: 0,
    DisplayOrder: reward.level * 2 + (reward.track === 'plus' ? 1 : 0),
    IsActive: false,
    Environment: environment,
    Tags: ['live_quest', 'season_1', reward.track, 'stickerPack'],
    MediaAssets: [{ Type: 'image', Url: cover.assetUrl, MimeType: cover.mimeType }],
    Metadata: {
      LiveQuestRewardId: reward.id,
      Track: reward.track,
      Level: reward.level,
      RewardType: reward.rewardType,
      Amount: reward.amount,
      StickerCount: members.length,
      StickerProductKeys: members.map((member) => member.productKey),
    },
  };
};
